import type { Account } from '../api'
import type { Progress, Scope } from '../../shared/progress'

export type { DayStat, Progress, Scope, ScopeKind } from '../../shared/progress'
export {
  DEFAULT_SCOPE,
  MASTERY_MAX,
  MAX_FACTOR,
  MIN_UPTO,
  factKey,
  factLabel,
  scopeFacts,
  scopePct,
} from '../../shared/progress'

export type Screen = 'home' | 'friends' | 'awards' | 'profile' | 'session' | 'result'

export type Mode = 'choice' | 'keypad' | 'match' | 'race' | 'boss'

export interface Pair {
  a: number
  b: number
  r: number
}

export interface Question {
  mode: Mode
  a: number
  b: number
  answer: number
  /** Варианты ответа — `choice`, `race`, `boss`. */
  opts: number[]
  /** Левая колонка раунда на соединение пар. */
  pairs: Pair[]
  /** Перемешанная правая колонка. */
  rights: number[]
}

export interface Settings {
  /** Какую часть таблицы тренируем. Хранится только локально. */
  scope: Scope
}

export interface Profile {
  firstName: string
  lastName: string
  age: number | null
  /** Ссылка на фото: своё из S3 или аватар из MAX. */
  avatarUrl: string | null
}

/** Чей прогресс вернётся по ключу из ссылки. */
export interface RestoreAsk {
  code: string
  name: string
  pct: number
}

/** Идёт ли обмен с сервером. `offline` — играем локально, синхронизируемся позже. */
export type SyncState = 'idle' | 'saving' | 'offline' 

export interface GameState {
  settings: Settings
  profile: Profile
  progress: Progress
  /** Аккаунт с сервера; null — пока не ответил (играем по локальному кэшу). */
  account: Account | null
  sync: SyncState
  /** Результат перехода по ссылке-приглашению — показываем на вкладке «Друзья». */
  inviteNote: string | null
  /** Пришли по ссылке с ключом: спрашиваем в «Профиле», возвращать ли прогресс. */
  restoreAsk: RestoreAsk | null
  /** Что пошло не так со ссылкой-ключом — показываем в «Профиле». */
  restoreNote: string | null
  screen: Screen
  /** Режимы текущей игры по порядку. */
  rounds: Mode[]
  idx: number
  hearts: number
  right: number
  wrong: number
  combo: number
  sessionXp: number
  lastXp: number
  q: Question | null
  fb: 'ok' | 'bad' | null
  /** Набранное на клавиатуре. */
  input: string
  /** Выбранная карточка левой колонки. */
  mLeft: number | null
  /** Индексы решённых пар. */
  mDone: number[]
  raceLeft: number
  raceScore: number
  bossHp: number
  /** Факты, на которых ошиблись в этой игре. */
  tricky: string[]
  /** Пока показывается реакция на ответ — нажатия игнорируются. */
  locked: boolean
}

export const MAX_HEARTS = 3
export const BOSS_HP = 3
export const RACE_SECONDS = 20
